<!-- 表格 -->
<template>
  <div class="table-container">
    <mtd-table
      :data="data"
      size="large"
      header-row-class="table-header"
      :row-class="tableRowClassName"
      :cell-class="cellClass"
    >
      <slot name="pre"></slot>
      <mtd-table-column
        v-for="(item, index) in columns"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :fixed="item.fixed"
        :width="item.width"
        :formatter="item.formatter"
        :align="item.align"
        :min-width="item.minWidth||'100px'"
        :class-name="item.className||''"
        :label-class="item.labelClass||''"
        :show-overflow-tooltip="!!item.showOverflowTooltip"
      >
        <template #header>
          <div
            class="column-header"
            :class="item.headerAlign"
          >
            {{ item.label }}
            <img
              v-if="item.tip"
              class="icon-question"
              src="@/assets/img/icon-question.png"
              @click.stop="$emit('show-tip',item.tip)"
            />
          </div>
        </template>
      </mtd-table-column>
      <slot></slot>
    </mtd-table>
  </div>
</template>
<script>
export default {
  name: 'BillTable',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    cellClass: {
      type: Function,
      default: () => '',
    },
  },
  data() {
    return {

    };
  },
  methods: {
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 0) {
        return 'odd-row';
      } else if (rowIndex % 2 === 1) {
        return 'even-row';
      }
      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
.table-container {
  /deep/ .mtd-table {
    .table-header th {
      background: #ffffff;
      padding: 30px 0;
    }
    .odd-row td {
      background: #F9F9F9;
    }
    .even-row td{
      background: #F3F3F3;
    }
  }
  .column-header {
    display: flex;
    align-items: center;
    &.center {
      justify-content: center;
    }
    .icon-question {
      margin-left: 6px;
      height: 24px;
      width: 24px;
    }
  }

}
</style>
